<template>
  <td class="table-data" :class="{ error: isError }">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: "TableData",
  props: {
    variant: { type: String, default: "" },
    hasError: { type: Array, default: () => [] },
  },
  computed: {
    isError() {
      return this.hasError.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.table-data {
  border-collapse: collapse;
  border: 1px solid $secondary;
  padding: 15px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  &.error {
    background: $warning;
  }
  @include mq-down(md) {
    display: block;
    width: 100%;
    border-top: 0;
    border-left: 0;
    border-right: 0;
  }
  @include mq-up(md) {
    padding: 20px;
    width: 75%;
  }
  &.-members {
    @include mq-down(md) {
      display: table-cell;
      width: 60%;
    }
  }
  :deep(> .name) {
    @include mq-up(md) {
      width: 185px;
      display: inline-block;
      line-height: 28px;
      &:nth-child(n + 2) {
        &:before {
          // vue2環境の余白に寄せるためスペースを挿入
          content: "\0020";
          white-space: pre;
        }
      }
    }
    @include mq-down(md) {
      display: block;
    }
  }
}

@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .table-data {
    vertical-align: middle;
    display: table-cell;
  }
}

.table-box.-members {
  .table-body {
    .table-row {
      .table-data {
        width: 66.66%;
        text-align: right;
        @include mq-down(md) {
          display: table-cell;
          width: 56%;
        }
      }
    }
  }
}

.table-box.-nextusage {
  .table-body {
    .table-row {
      .table-data {
        width: 66.66%;
        text-align: right;
        @include mq-down(md) {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>
